import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, input, output, signal } from '@angular/core';

import { Subscription, interval } from 'rxjs';

const DEFAULT_COUNTDOWN: number = 14;
const DEFAULT_INTERVAL: number = 1000;

@Component({
  selector: 'auth-timer',
  standalone: true,
  templateUrl: './timer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimerComponent implements OnInit, OnDestroy {
  countdown = input<number>(DEFAULT_COUNTDOWN);
  countdownCompleted = output<boolean>();

  private readonly intervalStep = DEFAULT_INTERVAL;

  protected readonly remainingTime = signal(this.countdown());
  private timer$: Subscription | undefined;

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  startTimer() {
    this.timer$ = interval(this.intervalStep).subscribe(() => {
      if (this.remainingTime() > 0) {
        this.remainingTime.update(time => {
          time = time - 1;
          return time;
        });
      } else {
        this.stopTimer();
        this.countdownCompleted.emit(true);
        this.remainingTime.set(this.countdown());
      }
    });
  }

  stopTimer() {
    if (this.timer$) {
      this.timer$.unsubscribe();
    }
  }
}
